import { useState } from 'react';
import { getHighlighted, getLatestAll, getTrending } from '@/lib/catalog';
import PageMeta from '@/components/feature/PageMeta';
import SiteLayout from '@/components/feature/SiteLayout';
import FilmCard from '@/components/feature/FilmCard';
import SectionHeading from '@/components/feature/SectionHeading';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryShortcuts from '@/pages/home/components/CategoryShortcuts';
import TrendList from '@/pages/home/components/TrendList';
import SiteIntro from '@/pages/home/components/SiteIntro';

const tabs = [
  { key: 'all', label: '全部' },
  { key: 'movie', label: '电影' },
  { key: 'tv', label: '电视剧' },
  { key: 'variety', label: '综艺' },
];

export default function Home() {
  const [tab, setTab] = useState('all');
  const highlighted = getHighlighted(5);
  const latest = getLatestAll(12);
  const trending = getTrending(8);

  const filteredLatest = tab === 'all' ? latest : latest.filter((film) => film.type === tab);

  return (
    <PageMeta
      title="91在线视频 - 高清影视在线播放平台"
      description="91在线视频为用户提供丰富的影视资源，包括最新电影、电视剧、综艺节目等多类别在线视频观看服务，满足多样化观影需求。"
      keywords="91在线视频,在线视频,影视在线播放,电影电视剧,视频资源"
    >
      <SiteLayout padded={false}>
        <HeroCarousel films={highlighted} />
        <CategoryShortcuts />

        <section aria-label="最新影视" className="w-full px-4 md:px-8 pt-14 md:pt-16">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <SectionHeading
              title="最新上线"
              subtitle="按上传时间排序，刚上新的影视作品第一时间出现在这里"
              icon="ri-time-line"
            />
            <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 self-start md:self-auto shrink-0">
              {tabs.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => setTab(item.key)}
                  className={`px-3.5 py-1.5 rounded-full text-xs whitespace-nowrap transition-colors cursor-pointer ${
                    tab === item.key
                      ? 'bg-primary-500 text-background-50 font-medium'
                      : 'text-foreground-600 hover:text-foreground-950'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {filteredLatest.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-x-4 gap-y-8" data-product-shop>
              {filteredLatest.map((film, index) => (
                <FilmCard key={film.id} film={film} index={index} />
              ))}
            </div>
          ) : (
            <div className="py-14 text-center text-sm text-foreground-500">该分类暂无最新作品，换个分类试试</div>
          )}
        </section>

        <section aria-label="热门推荐" className="w-full px-4 md:px-8 pt-16 md:pt-20">
          <SectionHeading
            title="热门推荐"
            subtitle="按站内访问量排序，大家都在看的作品"
            icon="ri-fire-line"
            moreTo="/category/movie"
            moreLabel="更多影视"
          />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-x-4 gap-y-8" data-product-shop>
              {trending.slice(0, 6).map((film, index) => (
                <FilmCard key={film.id} film={film} index={index} />
              ))}
            </div>
            <div className="lg:col-span-4">
              <TrendList films={trending.slice(0, 8)} />
            </div>
          </div>
        </section>

        <div className="mt-16 md:mt-20">
          <SiteIntro />
        </div>

        <section aria-label="全站最新" className="w-full px-4 md:px-8 pt-14 md:pt-16">
          <SectionHeading
            title="更多值得一看"
            subtitle="覆盖电影、剧集与综艺的精选合集，点开卡片查看详情"
            icon="ri-sparkling-line"
          />
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-x-4 gap-y-8" data-product-shop>
            {getTrending(24)
              .slice(-12)
              .reverse()
              .map((film, index) => (
                <FilmCard key={film.id} film={film} index={index} />
              ))}
          </div>
        </section>
      </SiteLayout>
    </PageMeta>
  );
}